/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import _ from 'lodash'
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import SmtpSettingsStore from '../../store/auto_action/SmtpSettingsStore'
import SmtpSettingStore from '../../store/auto_action/SmtpSettingStore'
import SmtpSettingView from '../../view/pages/auto_action/SmtpSettiongView'
import SmtpSettingActions from '../../action/auto_action/SmtpSettingActions'

class SmtpSettingContainer extends Component {
  static getStores() {
    return [SmtpSettingsStore, SmtpSettingStore]
  }

  static calculateState(prevState, props) {
    return {
      smtp_settings: SmtpSettingsStore.getState(),
      smtp_setting: SmtpSettingStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    SmtpSettingActions.fetchAll()

    const showEdit = _.propertyOf(this.state)('showEdit') || false
    if (showEdit) {
      if (this.state.match.params.id) {
        SmtpSettingActions.fetchOne(this.state.match.params.id)
      }
    }
  }

  render() {
    return SmtpSettingView(this.state)
  }
}

export default withRouter(Container.create(SmtpSettingContainer, { withProps: true }))
